import React from 'react'
import AdjustmentIcon from 'SVGS/AdjustmentIcon'
import Spinner from 'Common/Spinner';
import CustomInput from 'Common/CustomInput/CustomInput';
import CrossIcon from 'SVGS/CrossIcon';
import { Tooltip } from 'react-tooltip'

const FilterSearch = ({ filterCount, activeElement, handleToggle, loading, handleFilterSuperSearch, superSearchValue, ...rest }) => {
    const handleClear = () => {
        handleFilterSuperSearch({ target: { value: "" } })
    }
    return (
        <>

            <div className='relative w-full '>
                <div className='relative flex w-full '>
                    <CustomInput {...rest} value={superSearchValue} onChange={handleFilterSuperSearch} className='border outline-none focus:border-[#EDEEEF] border-r-0 border-[#EDEEEF] h-[29px] bg-[#F8FAFB] rounded-tr-none rounded-br-none' />
                    {/* <input type="search" value={superSearchValue} onChange={handleFilterSuperSearch} {...rest} className='border outline-none border-r-0 border-[#EDEEEF] py-2 pl-9 pr-1 rounded rounded-tr-none rounded-br-none h-[29px] bg-[#F8FAFB] w-full' /> */}
                    <div className='absolute transform -translate-y-1/2 text-secondaryLight right-2 top-1/2'>
                        {
                            superSearchValue ? loading ? <Spinner /> : <CrossIcon className="cursor-pointer" onClick={handleClear} /> : null
                        }

                    </div>
                </div>
            </div>

            <div className="bg-[#F8FAFB] p-1 relative border-[#EDEEEF] border  border-l-0 rounded  rounded-ss-none   rounded-es-none ">
                {!!filterCount && <span className="absolute top-0 z-[1] px-1 text-[8px] text-white rounded-full bg-primary">{filterCount}</span>}
                <AdjustmentIcon onClick={() => handleToggle(0)} className={`block    duration-[350ms] transform transition-all cursor-pointer ${activeElement === 0 ? "text-primary" : "text-secondaryLight"} `} />
            </div>
        </>

    )
}

export default FilterSearch